/* eslint-disable */
export default {
  dialPlaceholder: '이름 또는 번호 입력',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
